module.exports = __webpack_public_path__ + "static/media/icon-mov.2bced36c.svg";